import { render } from "./ProjectCardLastUpdate.vue?vue&type=template&id=191ffca5"
import script from "./ProjectCardLastUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectCardLastUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__